export class Renovartoken {
	public codCliente:string = "";
	public docEmpresa:string = "";
	public docUsuario:string = "";
	public codTipoPortal:string = "";
	public token:string = "";
}
